'use client';

import FaIcon from '@/components/icon/FaIcon/FaIcon';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { goMainOneTimeAuth } from '@/utils/functions';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from './ContactHeaderSideNode.module.scss';

function ContactHeaderSideNode() {
  return (
    <a href='/account/contact-history' className={`${utilsStyles.textSmall} ${styles.linkListItem}`}>
      <div className={styles.linkListItem}>
        返信一覧 &nbsp;
        <FaIcon icon={faChevronRight} size='sm' />
      </div>
    </a>
  );
}

export default ContactHeaderSideNode;
